import React from 'react';
import { ResetPanel } from '../components/common/ResetPanel';
import { useReset } from '../hooks/useReset';
import { getAllEntityConfigs } from '../lib/entity-config';

export function ResetPage() {
  const { reset } = useReset();
  const entityNames = getAllEntityConfigs().map(c => c.logicalName).sort();

  return <ResetPanel entityNames={entityNames} onReset={reset} />;
}
